import React, { useEffect, useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";

export default function DropdownComponent({ name, kName, option, bannerFilter, filterCallBack }) {
    const [data, setData] = useState(name);
    const [selectOptions, setSelectOptions] = useState("");
    const [purposeName, setPurposeName] = useState("");

    useEffect(() => {
        setSelectOptions(bannerFilter);
    }, [bannerFilter]);

    useEffect(() => {
        if (option.length > 0) {
            let findName = option.find((item) => item.type == bannerFilter?.[kName]?.toLowerCase());
            if (kName === "purpose") setPurposeName(findName?.oppositeName);
            else setPurposeName(findName?.name);
            setData(bannerFilter?.[kName] ? bannerFilter?.[kName] : name);
        }
    }, [bannerFilter, name, option]);

    const handleDropdown = (value, name) => {
        const optionData = { ...selectOptions };
        if (optionData["purpose"] === "rent") optionData["completion"] = "all";
        else if (optionData["purpose"] == "sale") optionData["rent_frequency"] = "";
        optionData[name] = value;
        setSelectOptions(optionData);
        filterCallBack(optionData);
    };

    return (
        <div className={`filter-dropdown year-dropdown ${kName === "purpose" ? "purpose_dropdown" : ""}`}>
            <DropdownButton title={purposeName ? purposeName : data}>
                {/* <DropdownButton title={data ? data : name}> */}
                <div className="dropdown-grid">
                    {option.map((value, i) => (
                        <Dropdown.Item as="span" key={i} className={data.toLowerCase() === value.type ? "active" : ""} onClick={() => handleDropdown(value.type, kName)}>
                            {name === "Buy" ? value?.oppositeName : value?.name}
                        </Dropdown.Item>
                    ))}
                </div>
            </DropdownButton>
        </div>
    );
}
